import { Add } from '@mui/icons-material'
import { Box, styled, Typography } from '@mui/material'
import InactiveForegroundPNG from '@public/images/background-apostle-inactive-card.png'
import ApostleCard from '@src/components/apostles/card/ApostleCard'
import * as R from 'ramda'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

const StyledApostleCard = styled(ApostleCard)`
  cursor: pointer;
`

const Empty = styled(Typography)`
  bottom: 3px;
  font-size: 16px;
  font-weight: 700;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
`

const Center = styled(Box)`
  bottom: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, 50%);
`

const AddIcon = styled(Add)`
  color: white;
  height: 50px;
  width: 50px;

  filter: brightness(200);
`

const Overlay = ({ text, icon }: OverlayProps) => {
  return (
    <Box>
      <Center>
        {icon !== undefined ? icon : <AddIcon className='Custom-Add-Icon' />}
      </Center>
      <Empty className='Custom-Overlay-Text'>{text}</Empty>
    </Box>
  )
}

const EmptyApostleSlot = ({
  text,
  dimmed,
  overlay,
  icon,
  className
}: Props) => {
  const { t } = useTranslation()

  return (
    <Box className={className}>
      <StyledApostleCard
        apostle={null}
        className='Custom-Card'
        disabled
        foregroundImage={InactiveForegroundPNG.src}
        overlay={
          overlay !== undefined ? (
            overlay
          ) : (
            <Overlay
              text={R.isNil(text) ? t('apostle.empty') : text}
              icon={icon}
            />
          )
        }
        dimmed={dimmed}
      />
    </Box>
  )
}

type OverlayProps = {
  text?: string
  icon?: ReactNode
}

type Props = {
  className?: string
  text?: string
  dimmed?: boolean
  overlay?: ReactNode
  icon?: ReactNode
}

export default EmptyApostleSlot
